const riot = require('riot');

riot.tag2('modal-image', '<div class="relative h100vh w100vw f fh bg-white opacity-100" ref="modal" onclick="event.stopPropagation();"> <div class="z1 title f fh fs24 text-black p32 transition cursor-pointer" onclick="{fadeOut}"> <div class="w200"><img class="rotate-4deg object-fit-contain" src="/images/sign_text.PNG"></div> </div> <div class="absolute trbl0"><img class="block s-full object-fit-cover" src="/images/top_bg_image.jpeg"> <div class="absolute trbl0 bg-white opacity-70"></div> </div> </div>', 'modal-image .title:hover,[data-is="modal-image"] .title:hover{transform:scale(1.1)}', 'spat-animation="fade"', function(opts) {
    this.on('mount', async () => {

    });

    this.fadeOut = async () => {
      this.refs.modal.classList.add('opacity-0');
      this.close();
    };
});